import { useApp } from '../context/AppContext';
import { LegalLayout } from '../components/LegalLayout';
import { Shield, Calendar } from 'lucide-react';

export default function PrivacyPolicy() {
  const { privacyPolicy, appConfig, loading } = useApp();

  if (loading) {
    return (
      <div className="min-h-screen pt-24 flex items-center justify-center" data-testid="privacy-loading">
        <div className="animate-pulse text-muted-foreground">Loading Privacy Policy...</div>
      </div>
    );
  }

  const lastUpdated = privacyPolicy?.last_updated 
    ? new Date(privacyPolicy.last_updated).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    : 'N/A';

  return (
    <div className="min-h-screen pt-24 pb-16" data-testid="privacy-policy-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-12 pb-8 border-b border-border">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
              <Shield className="w-6 h-6 text-primary" strokeWidth={1.5} />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-bold text-foreground" data-testid="privacy-title">
                Privacy Policy
              </h1>
              <p className="text-muted-foreground">
                {appConfig.app_name}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Calendar className="w-4 h-4" />
            <span>Last Updated: {lastUpdated}</span>
          </div>
        </div>

        {/* Content */}
        {privacyPolicy?.content ? (
          <LegalLayout 
            content={privacyPolicy.content} 
            title="Privacy Policy"
          />
        ) : (
          <div className="text-center py-12 text-muted-foreground" data-testid="privacy-no-content">
            No privacy policy content available. Please generate one from the Admin panel.
          </div>
        )}
      </div>
    </div>
  );
}
